import { getRouteApi } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import Loading from '@/components/Loading'
import BasicLayout from '@/components/common/BasicLayout/BasicLayout'
import { toast } from '@/hooks/useToast'
import queryClient from '@/queryClient'

import SchoolYearForm from '../components/SchoolYearForm'
import useEditSchoolYear from '../mutations/useEditSchoolYear'
import { useSchoolYear } from '../queries/useSchoolYear'

const routeApi = getRouteApi('/_auth/school-settings/years/$yearId/edit')

const SchoolYearEditView = () => {
  const navigate = routeApi.useNavigate()
  const { yearId } = routeApi.useParams()
  const { t } = useTranslation(['schoolSettings', 'common'])

  const { data: year } = useSchoolYear(yearId)

  const {
    mutate: editSchoolYear,
    isPending: isEditSchoolYearPending,
    formErrors
  } = useEditSchoolYear({
    onSuccess: () => {
      toast({
        variant: 'success',
        title: t('toast.school-year-edit-success')
      })
      queryClient.invalidateQueries({
        queryKey: ['panelPeriodsYearsRetrieve', yearId]
      })
      queryClient.invalidateQueries({
        queryKey: ['panelPeriodsYearsList']
      })
      navigate({
        to: '/school-settings/years/$yearId',
        params: {
          yearId
        }
      })
    },
    onError: () => {
      toast({
        variant: 'error',
        title: t('toast.school-year-edit-error')
      })
    }
  })

  const defaultValues = year
    ? {
        firstSemester: {
          from: year.firstSemester.startDate,
          to: year.firstSemester.endDate
        },
        secondSemester: {
          from: year.secondSemester.startDate,
          to: year.secondSemester.endDate
        }
      }
    : undefined

  return (
    <BasicLayout
      breadcrumbs={[
        {
          title: t('common:navigation.school-settings'),
          to: '/school-settings'
        },
        {
          title: t('header.edit-school-year')
        }
      ]}
      header={t('header.edit-school-year')}
      moduleName={t('common:header.administration')}
    >
      <Loading spinning={isEditSchoolYearPending}>
        {defaultValues ? (
          <SchoolYearForm
            errors={formErrors}
            defaultValues={defaultValues}
            onSubmit={payload => {
              editSchoolYear({
                ...payload,
                id: yearId
              })
            }}
          />
        ) : null}
      </Loading>
    </BasicLayout>
  )
}

export default SchoolYearEditView
